import PropTypes from 'prop-types';
import React from 'react';

import config from '../../config';
import { translate as t } from '../../lib/I18n';

import Icon from '../general/Icon';
import BaseModal from '../general/BaseModal';

function LogoutWarningModal ({ onClose }) {
    const modalProps = {
        disableBlur: true,
        disableEscape: true,
        titleText: 'account.logoutWarning',
        onClose,
        className: "modal--sm logout-warning-modal",
        hideContinue: true,
        backdropClassName: "logout-warning-modal",
    };

    return (
        <BaseModal { ...modalProps }>
            <div className="vertical-align-parent full-height">
                <div className="confirmation vertical-align text-center">
                    <Icon icon="clock" className="margin-bottom--sm otrl-xl" />

                    <p className="alert-warning text-weight--normal">
                        { t('account.logoutWarning.almostTime') }
                    </p>

                    <p className="text-center">
                        { t('account.logoutWarning.possibleReasons', {
                            autoLogoutMinutes: config.get('autoLogoutMinutes')
                        }) }
                    </p>
                </div>
            </div>
        </BaseModal>
    );
}


LogoutWarningModal.propTypes = {
    onClose: PropTypes.func.isRequired
};


export default LogoutWarningModal;
